import { AuthenticationService } from '@alfresco/adf-core';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TokenAssinadorService } from './token-assinador.service';
import { TokenAssinadorModel } from './tokenAssinador.model';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { ClienteService } from 'app/service/cliente/cliente.service';
import { MatDialog } from '@angular/material/dialog';
import { DialogConfirmComponent } from 'app/components/dialog/dialog-confirm/dialog-confirm.component';
import { PermissoesService } from 'app/service/usuario/permissoes.service';

@Component({
  selector: 'app-token-assinador',
  templateUrl: './token-assinador.component.html',
  styleUrls: ['./token-assinador.component.scss']
})
export class TokenAssinadorComponent implements OnInit {

  private arrayString: string;
  public tokenAss = false;
  public superUser = false;

  public acervo = false;
  public adm = true;
  public solicitacao = false;
  public loading = false;
  public tokenForm: FormGroup;
  public submit = false;
  public tokenModel = {} as TokenAssinadorModel;
  public tokenEdit = {} as TokenAssinadorModel;
  public clienteId;
  public card = false;
  public nameCliente;
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  public prioridade = false;

  constructor(
    private permissoesService: PermissoesService,
    private route: ActivatedRoute,
    private clienteService: ClienteService,
    private _snackBar: MatSnackBar,
    private dialog: MatDialog,
    private tokenService: TokenAssinadorService,
    private fb: FormBuilder,
    private authService: AuthenticationService) {
      this.route.params.subscribe(params => this.clienteId = params['clienteId']);

      this.getPermissionCliente(this.clienteId);
    }

  ngOnInit() {
    this.tokenForm = this.fb.group({
      id: [null],
      descricao: [null, Validators.required],
      tokenAssinatura: [null, Validators.required],
      cliente: [null],
      prioridade: [false]
    });
    this.getCliente(this.clienteId);
    this.listarTokenPorCliente();
  }

  getPermissionCliente(idCliente: number) {
    this.loading = true;
    this.permissoesService.getPermissionEmpresa(idCliente).subscribe(data => {
      const arrayAuthorityCliente: any[] = [];
      data.forEach(el => {
        arrayAuthorityCliente.push(el.authority);
      });
      this.permissoesService.setItemAuthority('authority-Empresa', arrayAuthorityCliente);
      this.getAuthority();
      this.loading = false;
    }, err => {
      this.loading = false;
      console.error(err);
      this.openSnackBarError('Ocorreu um erro, tente novamente mais tarde');
    });
  }

  getAuthority() {
    this.arrayString = this.permissoesService.getItemAuthority('authority-Empresa');
    if (this.arrayString.includes('EDIT_TOKEN_ASSINADOR')) {
      this.tokenAss = true;
    }
    if (this.arrayString.includes('SUPER_USER')) {
      this.superUser = true;
    }
  }

  getCliente(id) {
    this.clienteService.getClienteUnico(id).subscribe(data => {
      this.nameCliente = data.nomeFantasia;
      this.tokenForm.get('cliente').setValue(data);
    }, err => {
      console.error(err);
    });
  }


  onSubmit() {
    this.submit = true;
  }

  reset() {
    this.submit = false;
    this.tokenForm.get('descricao').setValue(null);
    this.tokenForm.get('tokenAssinatura').setValue(null);
  }

  deleteToken(aspectoId: number) {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: {name: 'Deseja apagar este token ?', from: 'token-assinador.component.ts'}
    });
    dialogRef.afterClosed().subscribe((confirmed: any) => {
      if (confirmed.apagar === true) {
        this.excluitToken(aspectoId);
      }
    });
  }

  saveOrEdit() {
    if (this.tokenEdit.id !== undefined && this.tokenEdit.id !== null) {
        // this.editarToken(this.tokenEdit);
        this.editToken(this.tokenEdit);
    } else {
      this.saveTokenToEmpresa();
    }
  }

  listarTokenPorCliente() {
    this.tokenService.listarTokenPorCliente(this.clienteId).subscribe(data => {
      this.tokenModel = data;
      this.card = true;
      this.inserir(data);
    }, err => {
      console.error(err);
      this.card = false;
    });
  }

  checkValue(e) {
    console.log(e.currentTarget.checked);
    this.prioridade = e.currentTarget.checked;
    if (this.prioridade) {
      this.tokenEdit['prioridade'] = true;
    } else {
      this.tokenEdit['prioridade'] = false;
    }
  }

  inserir(dados) {
    this.tokenService.inserirToken(dados).subscribe(data => {
      console.log(data);
    }, err => {
      console.error(err);
    });
  }

  salvarToken() {
    this.tokenService.salvarToken(this.tokenForm.value, this.prioridade).subscribe(data => {
      console.log(data);
      this.tokenModel = data;
      this.openSnackBarSuccess('Token adicionado com sucesso !');
      this.reset();
      this.listarTokenPorCliente();
    }, err => {
      console.error(err);
      this.openSnackBarError(err.error.message);
    });
  }

  saveTokenToEmpresa() {
    this.tokenService.addToken(this.tokenForm.value).subscribe(data => {
      this.tokenModel = data;
      this.openSnackBarSuccess('Token adicionado com sucesso !');
      this.reset();
      this.listarTokenPorCliente();
    }, err => {
      console.error(err);
      this.openSnackBarError('Parametro de Assinatura existente !');
    });
  }

  getDadosToEdit(dados) {
    console.log(dados);
    this.tokenEdit = dados;
  }

  editarToken(token: TokenAssinadorModel) {
    this.tokenService.editarToken(token, this.prioridade).subscribe(data => {
      this.tokenModel = data;
      this.openSnackBarSuccess('Token editado com sucesso !');
      this.reset();
      window.location.reload();
    }, err => {
      console.error(err);
      this.openSnackBarError(err.error.message);
    });
  }

  editToken(token: TokenAssinadorModel) {
    this.tokenService.editToken(token).subscribe(data => {
      this.tokenModel = data;
      this.openSnackBarSuccess('Token editado com sucesso !');
      this.reset();
      window.location.reload();
    }, err => {
      console.error(err);
      this.openSnackBarError(err.error.message);
    });
  }

  excluitToken(tokenId: Number) {
    this.tokenService.excluirDadoArquivistico(tokenId).subscribe(() => {
      this.card = false;
      this.listarTokenPorCliente();
      this.openSnackBarSuccess('Token excluído com sucesso !');
    }, err => {
      console.error(err);
    });
  }

  // SnackBares
  openSnackBarSuccess(message: string) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ['success-snackbar']
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message,'', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ['error-snackbar']
    });
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/assinatura-eletronica/token-assinador/token-assinador.component.ts